wbApp.controller('RentDetailAddItemDetailCtrl', ['$scope', 'rentCategorySvc', 'rentItemSvc',
function ($scope, rentCategorySvc, rentItemSvc) {

    var allCategories = rentCategorySvc.getAll();
    $scope.selectedCategory = {
        itemSelectionType: 0,
        minimumNumberOfRentedItem: 1,
        maximumNumberOfRentedItems: 1
    };

    $scope.model = {
        id: null,
        externalId: null,
        numberOfItemsToAdd: 1,
        rentCategoryId: null,
        itemTypeId: null
    };
        
    $scope.modelOrig = angular.copy($scope.model);

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        var models;
        if ($scope.selectedCategory.itemSelectionType == 1) { // Automatic
            models = _.times($scope.model.numberOfItemsToAdd, function(idx) {
                return {
                    //_id: idx + _.random(100, 9999999999),
                    id: null,
                    externalId: null,
                    rentCategoryId: $scope.model.rentCategoryId,
                    itemTypeId: $scope.model.itemTypeId
                }
            });
        } else {
            models = _.times(1, _.constant({
               // _id: $scope.model.id,
                id: $scope.model.id,
                externalId: null,
                rentCategoryId: $scope.model.rentCategoryId,
                itemTypeId: $scope.model.itemTypeId
            }));

            rentItemSvc.getAll().$promise.then(function (allItems) {
                var item = _.find(allItems, { id: models[0].id });
                models[0].itemTypeId = item.itemTypeId;
            });
        }


        $scope.isSaving = true;
        $scope.onAddItemDetailSave(models);
        $scope.$hide();

    }

    $scope.onCategoryChange = function () {
        allCategories.$promise.then(function () {
            $scope.selectedCategory = _.find(allCategories, { 'id': $scope.model.rentCategoryId });
            if (!!$scope.selectedCategory) {
                $scope.model.numberOfItemsToAdd = $scope.selectedCategory.minimumNumberOfRentedItem;
            }
        });
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };


    $scope.isFormValid = function() {
        return true;
    }


}]);
